export default "__VITE_ASSET__BtntWPno__"